import React, { useMemo, useState } from "react";
import "./DistinguishedAlumni.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const Icons = {
  Search: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  ),
  Chevron: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
};

const alumniData = [
  {
    name: "Apurb Sinha",
    classYear: "Class of 2004",
    title: "Head CRM & Analytics (Asia Pacific)",
    company: "Invesco Asset Management (INDIA) Private Ltd.",
    industry: "Finance",
    image: "/images/Alumni/Distinguised_Alumni/imgi_10_Sinha-Apurb-2004.jpg"
  },
  {
    name: "Vertika Chandra",
    classYear: "Class of 2005",
    title: "Practice Manager",
    company: "Cresco International Analytics Limited",
    industry: "Consulting",
    image: "/images/Alumni/Distinguised_Alumni/imgi_11_Vertika-Chandra.jpg"
  },
  {
    name: "Dhananjay Prajapati",
    classYear: "Senior Leadership",
    title: "Senior Director, Web Technology",
    company: "Zeus Learning",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_12_Dhananjay-Prajapati.jpg"
  },
  {
    name: "Gaurav Singh",
    classYear: "Class of 2010",
    title: "Head IT API & Banking Development",
    company: "Bandhan Bank",
    industry: "Banking",
    image: "/images/Alumni/Distinguised_Alumni/imgi_13_Gaurav-Singh.jpg"
  },
  {
    name: "Abhay Naik",
    classYear: "Class of 2007",
    title: "Tech Lead",
    company: "Elevate K12",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_14_Abhay-Naik.jpg"
  },
  {
    name: "Viral Sangavi",
    classYear: "Class of 2007",
    title: "Associate",
    company: "Nomura India Private Limited",
    industry: "Finance",
    image: "/images/Alumni/Distinguised_Alumni/imgi_15_Viral-Sangvi.jpg"
  },
  {
    name: "Nikhil Ahirrao",
    classYear: "Class of 2013",
    title: "Technical Lead and Project Manager",
    company: "Accenture in India",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_16_Nikhil-Ahirrao.jpg"
  },
  {
    name: "Om Shukla",
    classYear: "Class of 2020",
    title: "Software Engineer",
    company: "Homeville Group",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_17_Om-Shukla.jpg"
  },
  {
    name: "Sandeep Singh",
    classYear: "Class of 2008",
    title: "Manager MIS & IT",
    company: "Mumbai Monorail",
    industry: "Transport",
    image: "/images/Alumni/Distinguised_Alumni/imgi_18_Sandeep-Singh.jpg"
  },
  {
    name: "Nitin Singh",
    classYear: "Class of 2008",
    title: "Process Consultant",
    company: "LTI (Larsen & Toubro Infotech Division)",
    industry: "Consulting",
    image: "/images/Alumni/Distinguised_Alumni/imgi_19_Nitin-Singh-e1621099913114.jpg"
  },
  {
    name: "Malvika Sinha",
    classYear: "Class of 2008",
    title: "Agile Coach",
    company: "United Health Group",
    industry: "Healthcare",
    image: "/images/Alumni/Distinguised_Alumni/imgi_20_Malvika-Sinha.jpg"
  },
  {
    name: "Devraj Raut",
    classYear: "Class of 2009",
    title: "India U-19 Team Cricket Performance Analyst",
    company: "BCCI",
    industry: "Sports",
    image: "/images/Alumni/Distinguised_Alumni/imgi_21_Devraj-Raut-2009.jpg"
  },
  {
    name: "Kunal Bharti",
    classYear: "Class of 2009",
    title: "VP, Engineering",
    company: "Raw Engineering",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_22_Kunal-Bharti.jpg"
  },
  {
    name: "Rajiv Singh",
    classYear: "Class of 2010",
    title: "Tech Head",
    company: "GetParking (Play Time Media Pvt. Ltd.)",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_23_Rajiv-Singh.jpg"
  },
  {
    name: "Mahesh Jadhav",
    classYear: "Class of 2011",
    title: "Tech Lead",
    company: "LTI",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_24_Mahesh-Jadhav-2011.jpg"
  },
  {
    name: "Prashant Tiwari",
    classYear: "Class of 2012",
    title: "Team Leader",
    company: "Newgen Software Technologies Ltd",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_25_Prashant-Tiwari-2012.jpg"
  },
  {
    name: "Mugdha Deshpande",
    classYear: "Class of 2006",
    title: "Customer Success Manager",
    company: "Service Works",
    industry: "Business",
    image: "/images/Alumni/Distinguised_Alumni/imgi_26_Mugdha-Deshpande.jpg"
  },
  {
    name: "Tejas Wani",
    classYear: "Class of 2014",
    title: "Owner/Director",
    company: "Around the Globe Holidays",
    industry: "Travel",
    image: "/images/Alumni/Distinguised_Alumni/imgi_27_Tejas-Wani.jpg"
  },
  {
    name: "Pooja Sinha",
    classYear: "Class of 2014",
    title: "System Technical Analyst",
    company: "Oracle Financial Services Software Ltd.",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_28_Pooja-Sinha-2014.jpg"
  },
  {
    name: "Surabhi Chavan",
    classYear: "Class of 2015",
    title: "Business Analyst",
    company: "eBay Inc",
    industry: "Business",
    image: "/images/Alumni/Distinguised_Alumni/imgi_29_Surabhi-Chavan-2015.jpg"
  },
  {
    name: "Roidon Francis Rodrigues",
    classYear: "Class of 2016",
    title: "Software Associate",
    company: "Accenture Services Pvt Ltd",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_30_Roidon-Francis-Rodrigues.jpg"
  },
  {
    name: "Pooja Kamlesh Singh",
    classYear: "Class of 2017",
    title: "Software Associate",
    company: "Accenture Services Pvt Ltd",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_31_Pooja-Kamlesh-Singh-2017.jpg"
  },
  {
    name: "Abdul Vahid Khan",
    classYear: "Class of 2010",
    title: "Lead Software Engineer",
    company: "Cornerstone OnDemand",
    industry: "Technology",
    image: "/images/Alumni/Distinguised_Alumni/imgi_32_Abdul-Vahid-Khan.jpg"
  },
  {
    name: "Ravi Rajak",
    classYear: "Class of 2015",
    title: "Senior Engineering Team Lead",
    company: "PayNearby",
    industry: "Finance",
    image: "/images/Alumni/Distinguised_Alumni/imgi_33_Ravi-Rajak-2015.jpg"
  }
];

const yearOptions = ["All Years", ...new Set(alumniData.map((alumni) => alumni.classYear))];
const industryOptions = ["All Industries", ...new Set(alumniData.map((alumni) => alumni.industry))];

const getInitials = (name) =>
  name
    .split(" ")
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

const DistinguishedAlumni = () => {
  const [query, setQuery] = useState("");
  const [selectedYear, setSelectedYear] = useState("All Years");
  const [selectedIndustry, setSelectedIndustry] = useState("All Industries");

  const filteredAlumni = useMemo(() => {
    return alumniData.filter((alumni) => {
      const matchesQuery =
        alumni.name.toLowerCase().includes(query.toLowerCase()) ||
        alumni.company.toLowerCase().includes(query.toLowerCase()) ||
        alumni.title.toLowerCase().includes(query.toLowerCase());
      const matchesYear = selectedYear === "All Years" || alumni.classYear === selectedYear;
      const matchesIndustry =
        selectedIndustry === "All Industries" || alumni.industry === selectedIndustry;

      return matchesQuery && matchesYear && matchesIndustry;
    });
  }, [query, selectedIndustry, selectedYear]);

  return (
    <>
      <Navbar />
        <PageHeader
                  title="Our Distinguished Alumni"
                  crumbs={[
                    { label: "Home", href: "/" },
                    { label: "Our Distinguished Alumni" },
                  ]}
                />
      <div className="da-page-shell">

        <section className="da-grid-section">
          <div className="da-grid-header">
            <div>
              <p className="da-section-label">Featured Directory</p>
              <h2 className="da-section-title">Our Distinguished Alumni</h2>
            </div>
          
          </div>

          <div className="da-alumni-grid">
            {filteredAlumni.map((alumni) => (
              <article className="da-alumni-card" key={`${alumni.name}-${alumni.company}-${alumni.classYear}`}>
                <div className="da-avatar-ring">
                  {alumni.image ? (
                    <img
                      src={alumni.image}
                      alt={alumni.name}
                      className="da-avatar-image"
                    />
                  ) : (
                    <div className="da-avatar">{getInitials(alumni.name)}</div>
                  )}
                </div>
                <h3 className="da-card-name">{alumni.name}</h3>
                <p className="da-card-year">{alumni.classYear}</p>
                <p className="da-card-role">{alumni.title}</p>
                <p className="da-card-company">{alumni.company}</p>
              </article>
            ))}
          </div>

          {filteredAlumni.length === 0 && (
            <div className="da-empty-state">
              <h3>No alumni matched your filters</h3>
              <p>Try a different name, year, or industry to explore more profiles.</p>
            </div>
          )}

          <div className="da-directory-link">
            <span>For more details visit</span>
            <a
              href="https://www.alumni.timscdrmumbai.in"
              target="_blank"
              rel="noreferrer"
            >
              alumni.timscdrmumbai.in
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default DistinguishedAlumni;